import FingerprintJS from '@fingerprintjs/fingerprintjs'

/**
 * Generates a unique visitor identifier (fingerprint) using FingerprintJS
 * This fingerprint is based on various browser and device characteristics
 * to create a stable identifier for the visitor
 * 
 * @returns {Promise<string>} A promise that resolves to a unique visitor identifier
 * @throws {Error} If the fingerprint generation fails
 * 
 * @example
 * try {
 *   const visitorId = await getFingerprint();
 *   console.log('Visitor ID:', visitorId);
 * } catch (error) {
 *   console.error('Failed to generate fingerprint:', error);
 * }
 */
export async function getFingerprint(): Promise<string> {
  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()

    if (!result?.visitorId) {
      throw new Error('No fingerprint generated')
    }

    // Retourner l'identifiant du visiteur
    return result.visitorId
  } catch (error) {
    console.error('Error generating fingerprint:', error)
    throw error
  }
}
